import styled from 'styled-components';

import { GetDeliveryQuery } from 'data/__generated__';

import { SectionContainer } from 'components/DetailsView/Section';
import { DataTable } from 'components/DataTable';

import { deliveryOrdersColumns, DeliveryOrderRow } from './constants/deliveryOrdersColumns';
import { ProductSummaryTable } from './components/ProductSummaryTable';

export const OrdersSection = ({ delivery }: { delivery: NonNullable<GetDeliveryQuery['delivery']> }) => {
    const { orders, ordersProductSummary } = delivery;

    if (orders.length === 0) {
        return null;
    }

    return (
        <SectionContainer title={`Commandes (${orders.length})`} isInitiallyOpen={false}>
            <Container>
                <Subtitle>Liste des commandes</Subtitle>
                <TableContainer style={{ height: Math.min(400, 110 + orders.length * 44) }}>
                    <DataTable<DeliveryOrderRow>
                        columns={deliveryOrdersColumns}
                        data={orders}
                        filterMode="client"
                        getRowId={(row) => row._id}
                        getRowLink={(row) => `/order/${row._id}`}
                        searchPlaceholder="N° commande, client…"
                        searchFilterKey="searchValue"
                        disableUrlSync
                        disableColumnVisibility
                        autoFocusSearch={false}
                    />
                </TableContainer>
                <Subtitle>Récapitulatif par produit (demandé / positionné / soldouts)</Subtitle>
                <ProductSummaryTable summary={ordersProductSummary} />
            </Container>
        </SectionContainer>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Subtitle = styled.div`
    font-weight: 700;
    margin-top: 5px;
`;

const TableContainer = styled.div`
    overflow: hidden;
`;
